export default "__VITE_ASSET__BryHh21w__"